// extracted by mini-css-extract-plugin
module.exports = {"whiteboardMenuContent":"WhiteboardMenuContent_whiteboardMenuContent__3wcd9","brushSizeWrapper":"WhiteboardMenuContent_brushSizeWrapper__3y0-O"};